import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutGrid2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutGrid2"><Path d="M3.5 3.5H10.5V10.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M13.5 3.5H20.5V10.5H13.5V3.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M3.5 13.5H10.5V20.5H3.5V13.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M13.5 13.5H20.5V20.5H13.5V13.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconLayoutGrid2;
